import { useState } from "react";
import TaskDetailView from "@/components/TaskDetailView";
import { CloseButton } from "@/components/shared/PagePrimitives";
import { DetailNav } from "@/components/shared/ListNav";
import { DetailDock, useDockEscape } from "@/components/shared/DetailDock";

// 360: Úkoly › Seznam na počítači — detail úkolu vyjede vpravo vedle tabulky (tabulka se zúží na Název
// a Termín), ne přes ni. Panel je přilepený k oknu a vysoký přes zbytek obrazovky; ↑ ↓ a mezerník
// obsluhuje seznam (useListNav), Esc zavře. Hlavička: potvrzení úkolu vlevo (357/358), „2 / 14 ↑ ↓ ✕“ vpravo.
// 370: obal (přilepení, výška, vyjetí zprava) je sdílený s Doklady — DetailDock.
export function TaskDock({ taskId, nav, onClose, onChanged, initialAction }) {
  const [slot, setSlot] = useState(null);
  useDockEscape(onClose);
  return (
    <DetailDock label="Detail úkolu" testid="task-dock" className="shrink-0 w-[clamp(440px,46%,720px)]">
      <div className="h-full grid grid-rows-[auto_minmax(0,1fr)] bg-card border border-border rounded-[24px] overflow-hidden shadow-[0_12px_40px_rgba(0,0,0,.10)]">
        <div className="flex items-center justify-between gap-3 px-5 py-3 border-b border-border/60" data-testid="task-dock-header">
          <div ref={setSlot} className="flex items-center gap-2 min-w-0" data-testid="task-modal-actions" />
          <div className="flex items-center gap-1.5 shrink-0">
            <DetailNav nav={nav} testid="review-nav" noun="úkol" />
            <CloseButton testid="task-dock-close" onClick={onClose} title="Zavřít (mezerník / Esc)" />
          </div>
        </div>
        <div className="overflow-y-auto overscroll-contain px-5 py-5" data-testid="task-dock-body">
          {taskId && <TaskDetailView key={taskId} id={taskId} onChanged={onChanged} onClose={onClose} initialAction={initialAction} headerSlot={slot} keys="dock" />}
        </div>
      </div>
    </DetailDock>
  );
}
